export function num(v) {
  if (v == null || v === "") return 0;
  const n = Number(v);
  return Number.isNaN(n) ? 0 : n;
}

function ndsShare(sumWith, ndsAmount) {
  const total = num(sumWith);
  if (!total) return null;
  return Math.round((num(ndsAmount) / total) * 10000) / 10000;
}

function emptyNode(id, nodeType, label, extra = {}) {
  return {
    id,
    node_type: nodeType,
    label,
    children: [],
    qty: null,
    unit_name: "",
    price_with_nds: null,
    price_without_nds: null,
    sum_with_nds: 0,
    sum_without_nds: 0,
    nds_amount: 0,
    nds_share_percent: null,
    ...extra,
  };
}

function addMoney(node, row) {
  node.sum_with_nds += num(row.sum_with_nds);
  node.sum_without_nds += num(row.sum_without_nds);
  node.nds_amount += num(row.nds_amount);
  node.nds_share_percent = ndsShare(node.sum_with_nds, node.nds_amount);
}

export function buildUspMaterialsNdsTree(rows, residentName) {
  const root = emptyNode("resident", "resident", residentName || "ЖК");
  const projectMap = new Map();

  for (const row of rows || []) {
    const pKey = String(row.sbs_project_id ?? row.usp_project_name ?? "p");
    let project = projectMap.get(pKey);
    if (!project) {
      project = emptyNode(
        `p:${pKey}`,
        "project",
        row.usp_project_name || residentName || "Проект",
        { sbs_project_id: row.sbs_project_id }
      );
      project._konstruktiv = new Map();
      projectMap.set(pKey, project);
      root.children.push(project);
    }

    const kName = row.konstruktiv_name || "Без привязки УСП";
    let konstruktiv = project._konstruktiv.get(kName);
    if (!konstruktiv) {
      konstruktiv = emptyNode(`k:${pKey}:${kName}`, "konstruktiv", kName, {
        unmapped_reason: row.unmapped_reason || null,
      });
      project._konstruktiv.set(kName, konstruktiv);
      project.children.push(konstruktiv);
    }

    const mat = emptyNode(
      `m:${pKey}:${kName}:${row.material_id}`,
      "material",
      row.material_name || String(row.material_id || "—"),
      {
        material_id: row.material_id,
        unit_name: row.unit_name || "",
        qty: num(row.material_qty),
        price_with_nds: num(row.price_with_nds),
        price_without_nds: num(row.price_without_nds),
        sum_with_nds: num(row.sum_with_nds),
        sum_without_nds: num(row.sum_without_nds),
        nds_amount: num(row.nds_amount),
        nds_share_percent:
          row.nds_share_percent == null ? null : num(row.nds_share_percent),
        unmapped_reason: row.unmapped_reason || null,
        is_nds_mixed: !!row.is_nds_mixed,
      }
    );
    konstruktiv.children.push(mat);
    addMoney(konstruktiv, row);
    addMoney(project, row);
    addMoney(root, row);
  }

  for (const project of root.children) {
    delete project._konstruktiv;
  }
  return [root];
}

export function collectExpandableIds(nodes, acc = []) {
  for (const node of nodes || []) {
    if (node.children?.length) {
      acc.push(node.id);
      collectExpandableIds(node.children, acc);
    }
  }
  return acc;
}

export function buildFilterOptionsFromRows(rows) {
  const konstruktiv = new Map();
  const materials = new Map();
  for (const row of rows || []) {
    const kName = row.konstruktiv_name || "Без привязки УСП";
    if (!konstruktiv.has(kName)) {
      konstruktiv.set(kName, { label: kName, value: kName });
    }
    const mid = row.material_id;
    if (mid != null && !materials.has(mid)) {
      materials.set(mid, {
        label: row.material_name || String(mid),
        value: mid,
      });
    }
  }
  return {
    konstruktivs: [...konstruktiv.values()].sort((a, b) =>
      String(a.label).localeCompare(String(b.label), "ru")
    ),
    materials: [...materials.values()].sort((a, b) =>
      String(a.label).localeCompare(String(b.label), "ru")
    ),
  };
}

export function isFilterActive(v) {
  return v != null && v !== "" && v !== 0;
}
